import { Container } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import GravityForms from ".";
import useSite from "../../hooks/use-site";

const GravityFormLookUp = ({ formId }) => {
  const { acfData } = useSite();

  const [formData, setFormData] = useState(false);

  useEffect(() => {
    let propsFormData = false;

    // Check if Form Data is on top line
    const topLevel = acfData.filter(({ name }) => name === "acf/form");

    if (topLevel.length) {
      propsFormData = topLevel[0].acfFieldValues;
    } else {
      acfData.map(({ innerBlocks }) => {
        innerBlocks.map(({ name, acfFieldValues }) => {
          if (name === "acf/gform") {
            if (acfFieldValues?.formId === formId) {
              propsFormData = acfFieldValues;
            }
          }
        });
      });
    }

    setFormData(propsFormData);
  }, [formId]);

  return (
    <Container
      sx={{
        "input, select, textarea, label": {
          fontSize: "16px",
        },
        "label:not(.chakra-checkbox)": {
          fontWeight: "bold",
        },
      }}
    >
      {formData && <GravityForms form={formData} />}
    </Container>
  );
};

export default GravityFormLookUp;
